import { Button } from "primereact/button"
import { Tooltip } from "primereact/tooltip"
import { FC, useContext, useEffect, useState } from "react"
import { IAdminTable } from "../../models/AdminModel"
import './errors.css'
import { ErrorTable } from "./ErrorTable/ErrorTable"
import { TypifyErrorModal } from "./TypifyErrorModal/TypifyErrorModal"
import { getAllErrors } from "../../services/errors-service"
import { error } from "../../utils/notifications"
import { catchResponse } from "../../utils/helperFunctions"
import { FiCommand } from "react-icons/fi"
import { useLocation } from "react-router-dom"
import { UserContext } from "../../Redux/UserContext"


export const Errors:FC<any> = () => {

    const location:any = useLocation();

    const [state] = useContext(UserContext)

    const [open, setOpen] = useState<boolean>(false)

    const [flagErrors, setFlagErrors] = useState<boolean>(false)

    const [loadingErrors, setLoadingErrors] = useState<boolean>(false)

    const [errors, setErrors] = useState<any[]>([])

    const [errorsMASTER, setErrorsMASTER] = useState<any[]>([])

    const [editMode, setEditMode] = useState<boolean>(false)

    const [selectedError, setSelectedError] = useState<any>()

    const handleOpenModal = () => {
       
        setOpen(true)
    }

    const handleOpenEditModal = () => {
        setOpen(true)
    }

    const fetchErrors = async() => {
        try {
            setLoadingErrors(true)
            const res = await getAllErrors()
            if(res.status === 200) {
                const {code,data,message} = res.data
                if(code === 200) {
                    setErrors(data)
                    setErrorsMASTER(data)
                    setLoadingErrors(false)
                } else {
                    error(message)
                    setLoadingErrors(false)
                }
            } else {
                error("No se han podido obtener los errores")
                setLoadingErrors(false)
            }
        } catch(err:any) {
            catchResponse(err)
            setLoadingErrors(false)

        }
    }

    useEffect(() => {
        fetchErrors()
    },[flagErrors])

    useEffect(() => {
        if(location.state && errors.length > 0) {
            let { visible,id } = location.state 
            setSelectedError(errors.find((err:any) => err.idtipoerror === id))
            setEditMode(true)
            setOpen(visible) 
        }
    },[errors])

    return (
        <div className="admin__wrapper">
            <TypifyErrorModal
                visible={open}
                setVisible={setOpen} 
                flagErrors={flagErrors}
                setFlagErrors={setFlagErrors}
                handleOpenModal={handleOpenModal}
                selectedError={selectedError}
                setSelectedError={setSelectedError}
                editMode={editMode}
                setEditMode={setEditMode}
                />

            <Button disabled={state?.rol_id !== undefined? [2,3,4,6].includes(state.rol_id) : true} style={{minWidth:200}} label="Tipificar Error" icon="pi pi-exclamation-triangle"  onClick={handleOpenModal}  outlined />

            {
                loadingErrors?
                <div style={{height:'85%',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                                {/*<Spinner message={comparativa?`Obteniendo comparativa de escenarios` : `Obteniendo información del escenario`}/>*/}
                    <FiCommand className="loading-icon" style={{fontSize:30,color:'red',opacity:0.6}} />
                    <span  style={{fontFamily:'var(--roboto-medium)',color:'gray',marginTop:'1rem'}}>Cargando información de los errores.</span>   
                </div>
                :
                <ErrorTable
                handleOpenEditModal={handleOpenEditModal}
                data={errors}
                dataMASTER={errorsMASTER}
                selectedError={selectedError}
                setSelectedError={setSelectedError}
                flagErrors={flagErrors}
                setFlagErrors={setFlagErrors}
                editMode={editMode}
                setEditMode={setEditMode}
                />

            }
            


        </div>
    )
}